import { ICommonLink } from '@src/models/common';

export const TASK: ICommonLink = {
  id: 'tasktrackerLink',
  href: '/tasktracker',
  name: 'Задачи',
  disableNextJs: true,
  tags: [
    'role.account-manager',
    'role.admin',
    'role.agency-manager',
    'role.agency-primary-manager',
    'role.client-manager',
    'role.client-primary-manager',
    'role.supervisor',
  ],
  icon: 'tasksOutline',
};

export const CABINET: ICommonLink = {
  id: 'cabinetLink',
  href: '/finance/cabinet',
  name: 'Пункт управления',
  disableNextJs: true,
  tags: ['role.agency-primary-manager', 'role.agency-manager', 'role.client-manager', 'role.client-primary-manager'],
  icon: 'finances',
  extraHrefList: ['/finance/stats'],
};

export const CLIENT: ICommonLink = {
  id: 'clientLink',
  href: '/clients',
  name: 'Клиенты',
  disableNextJs: true,
  tags: ['role.account-manager', 'role.admin', 'role.supervisor'],
  icon: 'clients',
};

export const ADMIN_STORE: ICommonLink = {
  id: 'adminStoreLink',
  href: '/admin-store',
  name: 'Витрина',
  disableNextJs: true,
  tags: ['role.admin', 'role.admin-content'],
  icon: 'showcase',
};
